import React from "react";
import ServicesSection from "../components/ServicesSection";
import PlansAccepted from "../components/PlansAccepted";
import CTASection from "../components/CTASection";
import { programs } from "../mock";
import { ShieldCheck } from "lucide-react";
import useSeo from "../hooks/useSeo";

const Services = () => {
  useSeo({
    title: "Home Care Services in Ohio | DODD, Personal & Respite Care | Caregivers Alliance",
    description: "DODD-certified home care services across Ohio: personal care & home health aides, companion care, respite care and medication reminders. MyCare Ohio & PASSPORT accepted. Serving all 88 Ohio counties.",
    keywords: "DODD home care services Ohio, PASSPORT home care Ohio, personal care Ohio, companion care Ohio, respite care Ohio, MyCare Ohio services",
    path: "/services",
  });
  return (
    <>
      <section className="brand-gradient text-white">
        <div className="mx-auto max-w-7xl px-4 py-16 text-center">
          <h1 className="font-display font-extrabold text-4xl md:text-5xl">Our Home Care Services</h1>
          <p className="mt-4 text-white/90 max-w-2xl mx-auto">
            Personalized, certified in-home care that helps your loved ones live safely and comfortably at home.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            {programs.map((p) => (
              <span key={p.name} className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm">
                <ShieldCheck className="h-4 w-4 text-[#5FD3A0]" /> {p.name}
              </span>
            ))}
          </div>
        </div>
      </section>
      <ServicesSection full />
      <PlansAccepted />
      <CTASection />
    </>
  );
};

export default Services;
